// src/components/leiaute/SideNav.js
import React, { useEffect, useRef, useState } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { BiMoneyWithdraw, BiSolidReport } from 'react-icons/bi';
import { MdLocalShipping, MdOutlineDeliveryDining, MdOutlineSell, MdStorage, MdTableBar } from 'react-icons/md';
import { GrConfigure } from 'react-icons/gr';
import { FaCalendarAlt, FaTools, FaUserPlus } from 'react-icons/fa';
import { FiChevronDown, FiX } from 'react-icons/fi';
import { HiOutlineSaveAs } from 'react-icons/hi';

import './SideNav.css';

import MarcaCad from '../../pages/produtos/marcas/MarcaCad';
import GrupoCad from '../../pages/produtos/grupos/GrupoCad';
import ProdutoCad from '../../pages/produtos/produtos/ProdutoCad';
import FormaPagCad from '../../pages/financeiro/FormaPagCad';
import AssinaturaCad from '../../pages/financeiro/AssinaturaCad';
import EmpresaCad from '../../pages/administrativo/EmpresaCad';
import FilialCad from '../../pages/administrativo/FilialCad';
import ConfigModuloCad from '../../pages/administrativo/ConfigModuloCad';
import ConfigDFeCad from '../../pages/administrativo/ConfigDFeCad';
import ConfigTEFCad from '../../pages/administrativo/ConfigTEFCad';
import ContaBancoCad from '../../pages/financeiro/ContaBancoCad';
import { ConfigTEFProvider } from '../../contexts/administrativo/ConfigTEFContext';
import { useCliente } from '../../contexts/pessoas/ClienteContext';
import ConfigPedidoCad from '../../pages/pedidos/ConfigPedidoCad';
import ChatBotWhatsappCad from '../../pages/pedidos/ChatBotWhatsappCad';
import ConfigWhatsCad from '../../pages/pedidos/ConfigWhatsCad';
import { TipoEntregaProvider } from '../../contexts/pedidos/TipoEntregaContext';
import TipoEntregaCad from '../../pages/pedidos/TipoEntregaCad';
import { TaxaEntregaProvider } from '../../contexts/pedidos/TaxaEntregaContext';
import TaxaEntregaCad from '../../pages/pedidos/TaxaEntregaCad';
import TaxaEntregaBairroCad from '../../pages/pedidos/TaxaEntregaBairroCad';
import { useConfigModulo } from '../../contexts/administrativo/ConfigModuloContext';
import { useFornecedor } from '../../contexts/pessoas/FornecedorContext';
import { useNatureza } from '../../contexts/vendas/NaturezaContext';
import MesaConfCad from '../../pages/controleBar/mesas/MesaConfCad';
import { MesaConfProvider } from '../../contexts/controleBar/mesas/MesaConfContext';
import StatusProdutoDelivery from '../../pages/produtos/produtos/StatusProdutoDelivery';
import { useUser } from '../../contexts/geral/UserContext';
import { usePedido } from '../../contexts/pedidos/PedidoContext';
import { FaBell } from 'react-icons/fa';
import { useTransporteFiscal } from '../../contexts/fiscal/TransporteFiscalContext';

const getActiveNavigation = (pathname, config, user) => {
  const groups = [
    { id: 'vendas', routes: ['/pdv', '/pesqNotas', '/pesqNotasItem', '/pesqCaixa', ...(user?.admin ? ['/'] : [])] },
    { id: 'estoque', enabled: config?.controleEstoque, routes: ['/entrada', ['/entrada/:notaId', '/entrada'], '/importarXML', '/consultaEntradas', '/PesqNotaItemEntradaPage', '/pesqEstoque'] },
    { id: 'orcamentos', enabled: config?.usaOS, routes: ['/orcamento', '/orcamento/consultar', ['/orcamento/:id', '/orcamento']] },
    { id: 'servicos', enabled: config?.usaOS, routes: ['/ordemServico', '/ordemServico/consultar', ['/ordemServico/:id', '/ordemServico'], '/servicos/cadastros', '/servicos/tecnicos'] },
    { id: 'mdfe', enabled: config?.emiteMDFe, routes: ['/mdfe/emitir', '/mdfe/consultar'] },
    { id: 'mesas', enabled: config?.controleMesa, routes: ['/mesaPage', '/filtrarComandasPage', '/pesqComandaPage', ['/mesaControlePage/:mesaId', '/mesaPage'], '/'] },
    { id: 'pedidos', enabled: config?.moduloPedido, routes: ['/pedido', '/pesqPedido', '/pesqPedidoItem', '/whatsAppWeb', ...(user?.admin ? ['/dashPedidos'] : [])] },
    { id: 'financeiro', routes: ['/recebimento', ...(user?.admin ? ['/dashFinanceiro'] : [])] },
    { id: 'assinatura', enabled: config?.mensalidade, routes: ['/fatura/consultar'] },
    { id: 'leads', enabled: config?.mensalidade, routes: ['/leads/consultar'] },
    { id: 'relatorios', routes: ['/', '/relVendasGarcom', '/dashPedidos', ...(user?.admin ? ['/dashCliente', '/dashProdutos'] : [])] },
    { id: 'config', routes: ['/monitorImpressao'] },
  ];

  for (const group of groups) {
    if ('enabled' in group && !group.enabled) continue;
    for (const route of group.routes) {
      const [pattern, to] = Array.isArray(route) ? route : [route, route];
      if (matchPath({ path: pattern, end: true }, pathname)) return { group: group.id, to };
    }
  }
  return {};
};

function SideNav({ isOpen, setIsOpen, isMobile, onOpenUsuario }) {
  const { pathname } = useLocation();
  const sidenavRef = useRef(null);
  const closeButtonRef = useRef(null);
  const restoreFocusRef = useRef(true);
  const [openCadastros, setOpenCadastros] = useState(false);
  const [openMesas, setOpenMesas] = useState(false);
  const [openVendas, setOpenVendas] = useState(false);
  const [openFinanceiro, setOpenFinanceiro] = useState(false);
  const [openAssinatura, setOpenAssinatura] = useState(false);
  const [openLeads, setOpenLeads] = useState(false);
  const [openRelatorios, setOpenRelatorios] = useState(false);
  const [openConfig, setOpenConfig] = useState(false);
  const [openMDFe, setOpenMDFe] = useState(false);
  const [openServicos, setOpenServicos] = useState(false);
  const [openOrcamentos, setOpenOrcamentos] = useState(false);

  const [showModalGrupo, setShowModalGrupo] = useState(false);
  const [showModalMarca, setShowModalMarca] = useState(false);
  const [showModalProd, setShowModalProd] = useState(false);
  const [showStatusProd, setShowStatusProd] = useState(false);
  const [showModalFormaPag, setShowModalFormaPag] = useState(false);
  const [formaPag, setFormaPag] = useState(null);
  const [showModalContaBanco, setShowModalContaBanco] = useState(false);
  const [contaBanco, setContaBanco] = useState(null);
  const [showModalAssinatura, setShowModalAssinatura] = useState(false);
  const { showClienteCad } = useCliente();
  const { showFornecedorCad } = useFornecedor();
  const { showNaturezaCad } = useNatureza();
  const { configModuloSel } = useConfigModulo();
  const { user } = useUser();
  const { temPedidoNovo } = usePedido();



  //Configurações
  const [showModalEmpresa, setShowModalEmpresa] = useState(false);
  const [showModalFilial, setShowModalFilial] = useState(false);
  const [showModalConfigModulo, setShowModalConfigModulo] = useState(false);
  const [showModalConfigDFe, setShowModalConfigDFe] = useState(false);
  const [showModalConfigTEF, setShowModalConfigTEF] = useState(false);

  //Estoque
  const [openEstoque, setOpenEstoque] = useState(false);  

  // Mesas
  const [showModalMesaConf, setShowModalMesaConf] = useState(false);
  


  // Pedidos
  const [openPedidos, setOpenPedidos] = useState(false);
  const [showModalConfigPedido, setShowModalConfigPedido] = useState(false);
  const [showModalChatBotWhatsapp, setShowModalChatBotWhatsapp] = useState(false);
  const [showModalConfigWhats, setShowModalConfigWhats] = useState(false);
  const [showModalTipoEntrega, setShowModalTipoEntrega] = useState(false);
  const [showModalTaxaEntrega, setShowModalTaxaEntrega] = useState(false);
  const [showModalTaxaEntregaBairro, setShowModalTaxaEntregaBairro] = useState(false);

  const { showVeiculoCad, showCondutorCad, showSeguradoraCad } = useTransporteFiscal();
  const activeNavigation = getActiveNavigation(pathname, configModuloSel, user);

  useEffect(() => {
    const setters = {
      vendas: setOpenVendas, estoque: setOpenEstoque, orcamentos: setOpenOrcamentos,
      servicos: setOpenServicos, mdfe: setOpenMDFe, mesas: setOpenMesas,
      pedidos: setOpenPedidos, financeiro: setOpenFinanceiro,
      assinatura: setOpenAssinatura, leads: setOpenLeads, relatorios: setOpenRelatorios, config: setOpenConfig,
    };
    setters[activeNavigation.group]?.(true);
  }, [pathname, activeNavigation.group]);

  useEffect(() => {
    if (!isMobile || !isOpen) return undefined;
    const previousFocus = document.activeElement;
    restoreFocusRef.current = true;
    closeButtonRef.current?.focus();

    const handleKeyDown = (event) => {
      // Os modais usam portal; o teclado deles não deve ser capturado pelo menu.
      if (!sidenavRef.current?.contains(event.target)) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        setIsOpen(false);
      }
      if (event.key !== 'Tab') return;
      const focusable = [...sidenavRef.current.querySelectorAll('button:not(:disabled), a[href], [tabindex="0"]')]
        .filter((element) => element.getClientRects().length > 0);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      if (restoreFocusRef.current && previousFocus?.isConnected) previousFocus.focus();
    };
  }, [isMobile, isOpen, setIsOpen]);

  const getGroupProps = (group, open) => ({
    type: 'button',
    'aria-expanded': open,
    'aria-controls': `sidenav-${group}`,
    'data-active': activeNavigation.group === group ? 'true' : undefined,
  });

  const getLinkProps = (group, to) => ({
    'aria-current': activeNavigation.group === group && activeNavigation.to === to ? 'page' : undefined,
  });

  const handleSelectMenuItem = (event) => {
    if (!isMobile || !isOpen || !sidenavRef.current?.contains(event.target)) return;
    const item = event.target.closest('.sidenav-link, .sidenav-action');
    if (!item || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    restoreFocusRef.current = !item.classList.contains('sidenav-action');
    setIsOpen(false);
  };

  const handleOpenModalFormaPag = () => {
    setFormaPag(null);
    setShowModalFormaPag(true);
  };

  const handleCloseModalFormaPag = () => {
    setShowModalFormaPag(false);
  };

  const handleOpenModalContaBanco = () => {
    setContaBanco(null);
    setShowModalContaBanco(true);
  };

  const handleCloseModalContaBanco = () => {
    setShowModalContaBanco(false);
  };

  return (
    <>
    {isMobile && isOpen && (
      <button type="button" className="sidenav-backdrop" tabIndex={-1} aria-label="Fechar menu pelo fundo" onClick={() => setIsOpen(false)} />
    )}
    <aside
      id="sidenav-menu"
      ref={sidenavRef}
      className={`sidenav ${isOpen ? 'sidenav-open' : 'sidenav-closed'}`}
      role={isMobile && isOpen ? 'dialog' : undefined}
      aria-modal={isMobile && isOpen ? true : undefined}
      aria-label="Menu principal"
      inert={!isOpen ? true : undefined}
    >
      <header className="sidenav-header">
        {/* <div className="border-bottom d-flex align-items-center justify-content-center"> */}
          <img 
            src="/images/infomaiosidenav2.png"
            alt="Infomaio"
            className="sidenav-logo"
          />
        {/* </div> */}
        <button ref={closeButtonRef} type="button" className="sidenav-close" aria-label="Fechar menu principal" onClick={() => setIsOpen(false)}>
          <FiX aria-hidden="true" />
        </button>
      </header>

      <nav className="sidenav-content" aria-label="Navegação do sistema" onClickCapture={handleSelectMenuItem}>
        <div>
          <button {...getGroupProps('cadastros', openCadastros)}
            className="custom-button"
            onClick={() => setOpenCadastros(!openCadastros)}
            style={{ textDecoration: 'none' }}
          >
            <HiOutlineSaveAs aria-hidden="true" /> Cadastros
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openCadastros && (
            <div id="sidenav-cadastros" className="subitem">
              <button type="button" onClick={showClienteCad} className="sidenav-action">Clientes</button>
              <button type="button" onClick={showFornecedorCad} className="sidenav-action">Fornecedores</button>
              <button type="button" onClick={() => setShowModalProd(true)} className="sidenav-action">Produtos</button>
              
              <button type="button" onClick={() => setShowModalGrupo(true)} className="sidenav-action">Grupos</button>
              <button type="button" onClick={() => setShowModalMarca(true)} className="sidenav-action">Marcas</button>
              <button type="button" onClick={showNaturezaCad} className="sidenav-action">Naturezas</button>
              <GrupoCad show={showModalGrupo} onHide={() => setShowModalGrupo(false)} />
              <MarcaCad show={showModalMarca} onHide={() => setShowModalMarca(false)} />
              <ProdutoCad show={showModalProd} onHide={() => setShowModalProd(false)} />
              
            </div>
          )}
        </div>

        <div>
          <button {...getGroupProps('vendas', openVendas)}
            className="custom-button"
            onClick={() => setOpenVendas(!openVendas)}
            style={{ textDecoration: 'none' }}
          >
            <MdOutlineSell aria-hidden="true" /> Vendas
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openVendas && (
            <div id="sidenav-vendas" className="subitem">
              <Link to="/pdv" {...getLinkProps('vendas', '/pdv')} //onClick={() => setIsOpen(false)}
              className="sidenav-link">Vender</Link>
              <Link to="/pesqNotas" {...getLinkProps('vendas', '/pesqNotas')} className="sidenav-link">Consultar Notas</Link>
              <Link to="/pesqNotasItem" {...getLinkProps('vendas', '/pesqNotasItem')} className="sidenav-link">Consultar Itens</Link>
              <Link to="/pesqCaixa" {...getLinkProps('vendas', '/pesqCaixa')} className="sidenav-link">Resumo do Caixa</Link>
              { user?.admin && <Link to="/" {...getLinkProps('vendas', '/')} className="sidenav-link">Dashboard</Link> }
            </div>
          )}
        </div>

        {configModuloSel?.controleEstoque && (
        <div>
          <button {...getGroupProps('estoque', openEstoque)}
            className="custom-button"
            onClick={() => setOpenEstoque(!openEstoque)}
            style={{ textDecoration: 'none' }}
          >
            <MdStorage aria-hidden="true" /> Estoque
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openEstoque && (
            // <EstoqueProviders>
              <div id="sidenav-estoque" className="subitem">
                <Link to="/entrada" {...getLinkProps('estoque', '/entrada')} className="sidenav-link">Nova entrada</Link>
                <Link to="/importarXML" {...getLinkProps('estoque', '/importarXML')} className="sidenav-link">Importar XML</Link>
                <Link to="/consultaEntradas" {...getLinkProps('estoque', '/consultaEntradas')} className="sidenav-link">Consultar entradas</Link>
                <Link to="/PesqNotaItemEntradaPage" {...getLinkProps('estoque', '/PesqNotaItemEntradaPage')} className="sidenav-link">Consultar itens das entradas</Link>
                <Link to="/pesqEstoque" {...getLinkProps('estoque', '/pesqEstoque')} className="sidenav-link">Consultar Estoque</Link>
                {/* <Link onClick={() => alert('Função não implementada!')} className="text-white d-block">Configuração Estoque</Link> */}
                
              </div>
            // </EstoqueProviders>
          )}
        </div>)}

        {configModuloSel?.usaOS && (
        <div>
          <button {...getGroupProps('orcamentos', openOrcamentos)} className="custom-button" onClick={() => setOpenOrcamentos(!openOrcamentos)} style={{ textDecoration: 'none' }}>
            <HiOutlineSaveAs aria-hidden="true" /> Orçamento
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openOrcamentos && <div id="sidenav-orcamentos" className="subitem">
            <Link to="/orcamento" {...getLinkProps('orcamentos', '/orcamento')} className="sidenav-link">Novo Orçamento</Link>
            <Link to="/orcamento/consultar" {...getLinkProps('orcamentos', '/orcamento/consultar')} className="sidenav-link">Consultar Orçamentos</Link>
          </div>}
        </div>
        )}

        {configModuloSel?.usaOS && (
        <div>
          <button {...getGroupProps('servicos', openServicos)}
            className="custom-button"
            onClick={() => setOpenServicos(!openServicos)}
            style={{ textDecoration: 'none' }}
          >
            <FaTools aria-hidden="true" /> Serviços
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openServicos && (
            <div id="sidenav-servicos" className="subitem">
              <Link to="/ordemServico" {...getLinkProps('servicos', '/ordemServico')} className="sidenav-link">Nova OS</Link>
              <Link to="/ordemServico/consultar" {...getLinkProps('servicos', '/ordemServico/consultar')} className="sidenav-link">Consultar OS</Link>
              <Link to="/servicos/cadastros" {...getLinkProps('servicos', '/servicos/cadastros')} className="sidenav-link">Equipamentos e tipos</Link>
              <Link to="/servicos/tecnicos" {...getLinkProps('servicos', '/servicos/tecnicos')} className="sidenav-link">Técnicos</Link>
            </div>
          )}
        </div>
        )}

        {configModuloSel?.emiteMDFe && (
        <div>
          <button {...getGroupProps('mdfe', openMDFe)} className="custom-button" onClick={() => setOpenMDFe(!openMDFe)} style={{ textDecoration: 'none' }}>
            <MdLocalShipping aria-hidden="true" /> MDF-e
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openMDFe && (
            <div id="sidenav-mdfe" className="subitem">
              <Link to="/mdfe/emitir" {...getLinkProps('mdfe', '/mdfe/emitir')} className="sidenav-link">Emitir MDF-e</Link>
              <Link to="/mdfe/consultar" {...getLinkProps('mdfe', '/mdfe/consultar')} className="sidenav-link">Consultar MDF-e</Link>
              <button type="button" onClick={() => showVeiculoCad()} className="sidenav-action">Veículos</button>
              <button type="button" onClick={() => showCondutorCad()} className="sidenav-action">Condutores</button>
              <button type="button" onClick={() => showSeguradoraCad()} className="sidenav-action">Seguradoras</button>
            </div>
          )}
        </div>
        )}

        {configModuloSel?.controleMesa && (
        <div>               
          <button {...getGroupProps('mesas', openMesas)}
            className="custom-button"
            onClick={() => setOpenMesas(!openMesas)}
            style={{ textDecoration: 'none' }}
          >
            <MdTableBar aria-hidden="true" /> Mesas
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          <MesaConfProvider>
            {openMesas && (
              <div id="sidenav-mesas" className="subitem">
                <Link to="/mesaPage" {...getLinkProps('mesas', '/mesaPage')} className="sidenav-link">Gerenciar Mesas</Link>
                <Link to="/filtrarComandasPage" {...getLinkProps('mesas', '/filtrarComandasPage')} className="sidenav-link">Buscar Comandas</Link>
                <button type="button" onClick={() => setShowModalMesaConf(true)} className="sidenav-action">Cadastro de Mesas</button>
                <Link to="/pesqComandaPage" {...getLinkProps('mesas', '/pesqComandaPage')} className="sidenav-link">Consulta de Comandas</Link>
                <Link to="/" {...getLinkProps('mesas', '/')} className="sidenav-link">Dash Mesas</Link>
                
                {/* Modal MesaConfCad */}
                
                  <MesaConfCad 
                    show={showModalMesaConf} 
                    onHide={() => setShowModalMesaConf(false)} 
                  />
                
              </div>
            )}    
          </MesaConfProvider>      
        </div>
      )}

        {configModuloSel?.moduloPedido && (          
        <div>
          <button {...getGroupProps('pedidos', openPedidos)}
            className={`custom-button ${temPedidoNovo ? 'custom-button-pedidos-alerta' : ''}`}
            onClick={() => setOpenPedidos(!openPedidos)}
            style={{ textDecoration: 'none' }}
          >
            <span className="custom-button-label">
              <MdOutlineDeliveryDining aria-hidden="true" />
              <span>Pedidos</span>
              {temPedidoNovo && <><FaBell className="pedido-alert-icon" title="Novo pedido pendente" aria-hidden="true" /><span className="visually-hidden">Novo pedido pendente</span></>}
            </span>
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openPedidos && (
            
              <div id="sidenav-pedidos" className="subitem">
                <Link
                  to="/pedido" {...getLinkProps('pedidos', '/pedido')}
                  className={`sidenav-link ${temPedidoNovo ? 'sidenav-pedido-link-alerta' : ''}`}
                >
                  Gerenciar Pedidos
                </Link>
                <Link to="/pesqPedido" {...getLinkProps('pedidos', '/pesqPedido')} className="sidenav-link">Consultar Pedidos</Link>
                <Link to="/pesqPedidoItem" {...getLinkProps('pedidos', '/pesqPedidoItem')} className="sidenav-link">Consultar Itens</Link>
                <Link to="/whatsAppWeb" {...getLinkProps('pedidos', '/whatsAppWeb')} className="sidenav-link">WhatsApp Web</Link>
                <button type="button" onClick={() => setShowModalChatBotWhatsapp(true)} className="sidenav-action">Respostas Chatbot</button>
                <button type="button" onClick={() => setShowModalConfigPedido(true)} className="sidenav-action">Configuração Pedido</button>
                <button type="button" onClick={() => setShowStatusProd(true)} className="sidenav-action">Status Produtos</button>
                { user?.admin && <Link to="/dashPedidos" {...getLinkProps('pedidos', '/dashPedidos')} className="sidenav-link">Dashboard Pedidos</Link> }

                <ConfigPedidoCad show={showModalConfigPedido} onHide={() => setShowModalConfigPedido(false)} />
                <ChatBotWhatsappCad show={showModalChatBotWhatsapp} onHide={() => setShowModalChatBotWhatsapp(false)} />
                <StatusProdutoDelivery show={showStatusProd} onHide={() => setShowStatusProd(false)} />                

              </div>
            
          )}
        </div>        
        )}

        <div>
          <button {...getGroupProps('financeiro', openFinanceiro)}
            className="custom-button"
            onClick={() => setOpenFinanceiro(!openFinanceiro)}
            style={{ textDecoration: 'none' }}
          >
            <BiMoneyWithdraw aria-hidden="true" /> Financeiro
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openFinanceiro && (
            <div id="sidenav-financeiro" className="subitem">              
              <Link to="/recebimento" {...getLinkProps('financeiro', '/recebimento')} className="sidenav-link">Contas a Receber</Link>
              {/* <Link to="/pagamento" className="text-white d-block">Pagamentos</Link> */}
              <button type="button" onClick={handleOpenModalFormaPag} className="sidenav-action">Formas de Pagamento</button>
              <button type="button" onClick={handleOpenModalContaBanco} className="sidenav-action">Contas Bancárias</button>
              <FormaPagCad show={showModalFormaPag} onHide={handleCloseModalFormaPag} formaPag={formaPag} />
              <ContaBancoCad show={showModalContaBanco} onHide={handleCloseModalContaBanco} contaBanco={contaBanco} />
              {user?.admin && <Link to="/dashFinanceiro" {...getLinkProps('financeiro', '/dashFinanceiro')} className="sidenav-link">Dashboard Financeiro</Link>}
            </div>
          )}
        </div>

        {configModuloSel?.mensalidade && (
        <div>
          <button {...getGroupProps('assinatura', openAssinatura)}
            className="custom-button"
            onClick={() => setOpenAssinatura(!openAssinatura)}
            style={{ textDecoration: 'none' }}
          >
            <FaCalendarAlt aria-hidden="true" /> Assinatura
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openAssinatura && (
            <div id="sidenav-assinatura" className="subitem">
              <button type="button" onClick={() => setShowModalAssinatura(true)} className="sidenav-action">Cadastrar</button>
              <Link to="/fatura/consultar" {...getLinkProps('assinatura', '/fatura/consultar')} className="sidenav-link">Consultar</Link>
              <AssinaturaCad
                show={showModalAssinatura}
                onHide={() => setShowModalAssinatura(false)}
              />
            </div>
          )}
        </div>
        )}

        {configModuloSel?.mensalidade && (
        <div>
          <button {...getGroupProps('leads', openLeads)}
            className="custom-button"
            onClick={() => setOpenLeads(!openLeads)}
            style={{ textDecoration: 'none' }}
          >
            <FaUserPlus aria-hidden="true" /> Leads
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openLeads && (
            <div id="sidenav-leads" className="subitem">
              <Link to="/leads/consultar" {...getLinkProps('leads', '/leads/consultar')} className="sidenav-link">Consultar</Link>
            </div>
          )}
        </div>
        )}

        <div>
          <button {...getGroupProps('relatorios', openRelatorios)}
            className="custom-button"
            onClick={() => setOpenRelatorios(!openRelatorios)}
            style={{ textDecoration: 'none' }}
          >
            <BiSolidReport aria-hidden="true" /> Relatórios
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openRelatorios && (
            <div id="sidenav-relatorios" className="subitem">
              <Link to="/" {...getLinkProps('relatorios', '/')} className="sidenav-link">Vendas</Link>
              <Link to="/relVendasGarcom" {...getLinkProps('relatorios', '/relVendasGarcom')} className="sidenav-link">Vendas Garçom</Link>
              <Link to="/dashPedidos" {...getLinkProps('relatorios', '/dashPedidos')} className="sidenav-link">Pedidos</Link>
              { user?.admin && <Link to="/dashCliente" {...getLinkProps('relatorios', '/dashCliente')} className="sidenav-link">Clientes</Link> }
              { user?.admin && <Link to="/dashProdutos" {...getLinkProps('relatorios', '/dashProdutos')} className="sidenav-link">Produtos</Link> }
            </div>
          )}
        </div>

        <div>
          <button {...getGroupProps('config', openConfig)}
            className="custom-button"
            onClick={() => setOpenConfig(!openConfig)}
            style={{ textDecoration: 'none' }}
          >
            <GrConfigure aria-hidden="true" /> Configurações
            <FiChevronDown className="sidenav-chevron" aria-hidden="true" />
          </button>
          {openConfig && (
            <div id="sidenav-config" className="subitem">
              <Link to="/monitorImpressao" {...getLinkProps('config', '/monitorImpressao')} className="sidenav-link">Monitor Impressão</Link>
              <button type="button" onClick={onOpenUsuario} className="sidenav-action">Cadastrar Usuário</button>
              <button type="button" onClick={() => setShowModalEmpresa(true)} className="sidenav-action">Empresa</button>
              <button type="button" onClick={() => setShowModalFilial(true)} className="sidenav-action">Filial</button>
              <button type="button" onClick={() => setShowModalConfigModulo(true)} className="sidenav-action">Config Sistema</button>
              <button type="button" onClick={() => setShowModalTipoEntrega(true)} className="sidenav-action">Tipo de Entrega</button>
              <button type="button" onClick={() => setShowModalTaxaEntrega(true)} className="sidenav-action">Taxa de Entrega</button>
              {configModuloSel?.taxaEntregaBairro && (
                <button type="button" onClick={() => setShowModalTaxaEntregaBairro(true)} className="sidenav-action">Taxa Entrega Bairro</button>
              )}
              <button type="button" onClick={() => setShowModalConfigWhats(true)} className="sidenav-action">Configuração WhatsApp</button>
              <button type="button" onClick={() => setShowModalConfigDFe(true)} className="sidenav-action">Config para DF-e</button>
              <button type="button" onClick={() => setShowModalConfigTEF(true)} className="sidenav-action">Config para TEF</button>


              <EmpresaCad show={showModalEmpresa} onHide={() => setShowModalEmpresa(false)} />
              <FilialCad show={showModalFilial} onHide={() => setShowModalFilial(false)} />
              <ConfigModuloCad show={showModalConfigModulo} onHide={() => setShowModalConfigModulo(false)} />
              <ConfigDFeCad show={showModalConfigDFe} onHide={() => setShowModalConfigDFe(false)} />
              <ConfigTEFProvider>
                <ConfigTEFCad show={showModalConfigTEF} onHide={() => setShowModalConfigTEF(false)} />
              </ConfigTEFProvider>
              <TipoEntregaProvider>
                <TipoEntregaCad show={showModalTipoEntrega} onHide={() => setShowModalTipoEntrega(false)} />
              </TipoEntregaProvider>
              <TaxaEntregaProvider>
                <TaxaEntregaCad show={showModalTaxaEntrega} onHide={() => setShowModalTaxaEntrega(false)} />
              </TaxaEntregaProvider>
              <TaxaEntregaBairroCad show={showModalTaxaEntregaBairro} onHide={() => setShowModalTaxaEntregaBairro(false)} />

              
              <ConfigWhatsCad show={showModalConfigWhats} onHide={() => setShowModalConfigWhats(false)} />
              
            </div>
          )}
        </div>

      </nav>
    </aside>
    </>
  );
}

export default SideNav;
